'use client';

import { Align, Column, Columns } from '@bytel/trilogy-react';

import { OptionType, PlanType } from '@app-types/product';

import { ProductCatalogItem } from './product-catalog-item';

interface ProductsCatalogProps {
    catalogue: Array<PlanType>;
    blockedOption?: OptionType;
}

export function ProductsCatalog({ catalogue, blockedOption }: Readonly<ProductsCatalogProps>) {
    return (
        <Columns align={Align.CENTER}>
            <Column tabletSize={7} widescreenSize={5}>
                <Columns multiline>
                    {catalogue.map((product) => {
                        return (
                            <ProductCatalogItem
                                product={product}
                                key={product.gencode}
                                isHalfWidth
                                blockedOption={blockedOption}
                            />
                        );
                    })}
                </Columns>
            </Column>
        </Columns>
    );
}
